import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolOverviewTitle = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-overview-title">
      <h1 className="school-main-title h1">
        {t('service.school.overview.header')}
      </h1>
      <h2 className="school-main-subtitle">
        {t('service.school.overview.intro')}
      </h2>
      <div className="hidden sm:block sm:mb-8 sm:mt-8">
        <div className="media-photo bg-white">
          <Image
            fill
            className="flex-image"
            src="/images/ogImg.png"
            alt="LingualBox Class Image"
          />
        </div>
      </div>
    </div>
  );
};

export default SchoolOverviewTitle;
